import { render } from "./WellInfoTab.vue?vue&type=template&id=9f508b9a"
import script from "./WellInfoTab.vue?vue&type=script&lang=js"
export * from "./WellInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__